import React from 'react';
import Navbar from '../../components/navbar';
import FormularioNuevoCapi from '../../components2/formularioNuevoCapi';

function NuevoCapi () {
    return (
        <FormularioNuevoCapi />
    )
}

export default NuevoCapi;